import React from 'react'
import PropTypes from 'prop-types'

import { t } from 'src/lib/i18n-react'

import ActivityWrapupSkeleton from './ActivityWrapupSkeleton'
import WrapupCardVocabulary from './subcomponents/WrapupCardVocabulary/WrapupCardVocabulary'

const ActivityWrapupReview = ({ vocabularyGroups, ...rest }) => {
  const itemsLength = vocabularyGroups?.[0]?.items?.length

  return (
    <ActivityWrapupSkeleton
      titleSection={t('Good job!')}
      {...rest}
      subtitleSection={
        itemsLength > 0
          ? t(
              'You reviewed %{smart_count} item |||| You reviewed %{smart_count} items',
              { smart_count: itemsLength }
            )
          : null
      }
      vocabularySection={
        <WrapupCardVocabulary vocabularyGroups={vocabularyGroups} />
      }
    />
  )
}

ActivityWrapupReview.propTypes = {
  vocabularyGroups: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default ActivityWrapupReview
